import { useEffect } from "react";
import { applyMock, logger, normalizeDropdownOptionsData } from "@/utils";
import { AreasMock } from "@/pages/requests/components/areas/__mocks__/areas";
import { map } from "lodash";
import { useRequestState } from "@/hooks";
import { Area, requestAreasList } from "@/services/api";

export const useAreas = (
  email: string,
  contractId: number,
  companyId: number,
) => {
  const { data, error, setError, isLoading, setSuccess } =
    useRequestState<Area[]>();

  useEffect(() => {
    const controller = new AbortController();

    if (companyId) {
      requestAreasList({ email, companyId }, { signal: controller.signal })
        .then(response => {
          const data = normalizeDropdownOptionsData(
            response as Area[],
            "AreaNameEn",
          ) as Area[];

          const visibleItems = data?.filter((area: Area) => area.IsVisible);

          const transformedItems = map(visibleItems, (area: Area) => ({
            ...area,
            Company: {
              ...area.Company,
              Value: area.CompanyNameEn,
            },
          }));

          setSuccess(transformedItems);
        })
        .catch(error => {
          if (+window.APP_CONFIG.FEATURES.IS_MOCK_ENABLED) {
            const data = normalizeDropdownOptionsData(AreasMock, "AreaNameEn");

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            applyMock(data, setAreas, "requestAreasList");
          } else {
            logger.error(error);
            setError(error.message);
          }
        });
    } else {
      logger.error("companyId is not defined");
    }

    return () => {
      controller.abort();
    };
  }, [companyId, contractId, email, setError, setSuccess]);

  return { areas: data, error, isLoading };
};
